/**
 * Whether a query can be answered by the corpus index (ADR 000045).
 *
 * The index holds words of three letters or more, so a query of nothing but
 * short ones cannot be served: the API refuses it rather than returning the
 * whole corpus as if it matched (issue #178).
 *
 * The studio's job is to never ask. Typing "ai" should quietly fall back to
 * matching names, which happens client-side anyway, rather than flashing an
 * error halfway through a word.
 */
const MIN_TERM_LENGTH = 3;

/**
 * Reports whether a query has a word the index could match.
 *
 * Split on the same boundary the API tokenises on: anything that is not a
 * letter or a digit. Kept deliberately simple, because being slightly more
 * eager than the server costs one refused request and being less eager costs a
 * search that silently does nothing.
 */
export function searchable(query: string): boolean {
  return query.split(/[^\p{L}\p{N}]+/u).some((word) => word.length >= MIN_TERM_LENGTH);
}
